import { getVCObserver } from '@atlaskit/react-ufo/get-vc-observer';

export const initializeVCObserver = (rootNode: HTMLElement): void => {
	const vcObserver = getVCObserver();
	vcObserver.setSSRElement(rootNode);
	vcObserver.setReactRootRenderStart();
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			vcObserver.setReactRootRenderStop();
		});
	});
};
